
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as formsndyez4JHOK2073yxcbVGxp1BGyjQvuJLLwEaVpcjFIMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/activities/qinglvSettled/form.vue?macro=true";
import { default as recordG_xhTEbsRprNGQmaEu6TrzDGtH4mws_XL53F6HMhCmYMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/activities/qinglvSettled/record.vue?macro=true";
import { default as _91id_93jRXUnBnmRdm6w00Z8uPCl6iddZ0Z3l6cqwF3DPD_TYwMeta } from "/builds/se-team/deli-web-portal-front/app/pages/ai/share/doc/[id].vue?macro=true";
import { default as _91userId_93QqUBGQuDHAE5HiQrsGFfgHExgeUuX_5Xadqgpda5gJcMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/siq/consultSetting/[userId].vue?macro=true";
import { default as form8s9d5B6EMeo1bYHRpSmvnjuCrJGT3UOisL1SzztllU8Meta } from "/builds/se-team/deli-web-portal-front/app/pages/activities/qinglvSettled/form.vue?macro=true";
import { default as bNVmxiSHyLdnyS4fI6XCBxIK_2JUpMFF7evkhbPkj7MYa5oeGMNU7MMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/activities/bNVmxiSHyLd.vue?macro=true";
import { default as IJsaNibGVF9ZKQcxilhWv_FEGcQD3xI7P3OL3ba4MnN98RnbqW8Meta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/activities/IJsaNibG.vue?macro=true";
import { default as JgdUoFfDW7LSFleOfvOkKIW_L3GPSv7aS4oCruyzJ4MT9bACEUMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/activities/JgdUoFf.vue?macro=true";
import { default as index2uAQ1_GSFjQWCkOTUmauDO_ZhCPgGRisxCqc_NNJirUMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/activities/qinglvSettled/index.vue?macro=true";
import { default as shlxToDataI8sZBPc8K_ek1FF2wiIGBtw1_5mxqarDVz8wG8LwF5IMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/activities/shlxToData.vue?macro=true";
import { default as shlxToDlsv6SyDYlo77uWBYYfcs0FSZOMBWfgY7kUeUZWvr3GzIAMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/activities/shlxToDls.vue?macro=true";
import { default as agreementEti_TlfnFX12Nv7FkxxHXnXd_s70X40BP4ht_mZ3kqAMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ai/agreement.vue?macro=true";
import { default as caseDetailVj5kE5B4__1sivi6TeCYz7XSoHxCJhg20oKebygT608Meta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ai/caseDetail.vue?macro=true";
import { default as lawsDetailEg8h_cushMXNGdlf9BpHDLdtqJPNnVt7hwAUoWTdKlsMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ai/lawsDetail.vue?macro=true";
import { default as modelt_5hoH4Eh_I1swYsfqred1vcgZ2tHdoJj6Aw_o28Tw8Meta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ai/model.vue?macro=true";
import { default as siqModelZYtWB5Rw8tgdYGJj_S3u5r1rEApdomF2SUGXyWFLj_sMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ai/siqModel.vue?macro=true";
import { default as indexJX9DR4zV7ill3DeP4C06Nsf9rectKKSTtPvpZFpWn_oMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/dls/entry-form/index.vue?macro=true";
import { default as indexgfslCBwHlN1gtRjOz8EfNVp31y5oUcb5JSmNfOiU_UwMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/dls/lawyer-certification/index.vue?macro=true";
import { default as pointsf2RHVsvKRRjbpw217Sj62V7EWhdibiPcd_9MjY5ZD28Meta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/dls/points.vue?macro=true";
import { default as indexLMK4DzKaEP0udrXookntbKwGQy_RdN3SlhFPmMPEyhUMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/dls/points-rules/index.vue?macro=true";
import { default as aiSourceMessageFZt0f9ggLXuYgO8V_G9mg059Wv5CsSG0AIffJhUPLHgMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ft/aiSourceMessage.vue?macro=true";
import { default as businessCardpllg5NuAoYbxGIJ4p2nYHR92G3J5lSvVI3Cxz1dma_gMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ft/businessCard.vue?macro=true";
import { default as caseSourceMessage8j2WyBlM5TMREMczJQC4R4qEaMp59890dG4jSGmS10IMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ft/caseSourceMessage.vue?macro=true";
import { default as createCardhVyFnwLxHyzNJ8hkY0z1i7_akAYg4hthL6VEgNSl_UkMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ft/createCard.vue?macro=true";
import { default as helpT6AqV__DEMs2U0xXy4HGoHFdpmw9weCz9F2LVTRcvhUMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ft/help.vue?macro=true";
import { default as knowledgeDetailU4OiyvyjNT6YgzmT6bUqSVw_KCzLJWv7OgmqfJpz0S4Meta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ft/knowledgeDetail.vue?macro=true";
import { default as lawyerBusinessCardjAnYxAguSm37plDA_Zuggt4w7ZfqoKZYkX_kwANKFyIMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ft/lawyerBusinessCard.vue?macro=true";
import { default as leaveMessage_2lZ8Sv3eoj2yV7aEFxOe7n8VLdvJIT46an05rg_8qkMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ft/leaveMessage.vue?macro=true";
import { default as reportViewFSbCQUJ4UzIleuhdVjM0rkz3_3U_loLDX_5mhOqN2k0Meta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/ft/reportView.vue?macro=true";
import { default as assistantPlN6vmqGNwamXs1p13dbfyojzbgJd8pEucOxLHiVwcIMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/siq/assistant.vue?macro=true";
import { default as home_RYltP58VSUDSIuU7xBYDH1L5JQTxa6TXpX7nPXmwYEMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/siq/home.vue?macro=true";
import { default as lawyerCardeTnSSjwRhIq5DPINrI21c_IJj1wSyP1Xi3Rw5sEX6_IMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/siq/lawyerCard.vue?macro=true";
import { default as orderF9hvkjJfhP5Ngf32hNVf09jbJT89qsXxLMg7xHy9EhIMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/siq/order.vue?macro=true";
import { default as order_45detail1H06C8UeroZOC4Ld6casKC8P0JyCCtMYGP8mJQ1M1FwMeta } from "/builds/se-team/deli-web-portal-front/app/pages/h5/siq/order-detail.vue?macro=true";
import { default as _91id_93v5X0nmmcYQpq82b3je_pqZOOrPKSUzVe21U3RLQGTvEMeta } from "/builds/se-team/deli-web-portal-front/app/pages/ai/share/[id].vue?macro=true";
import { default as _91id_9361_pvCq1fH2N7EBAlwRwU1MKDnnMaD_RgtFv7bBpbxcMeta } from "/builds/se-team/deli-web-portal-front/app/pages/siq/consultLawyer/[id].vue?macro=true";
import { default as indexVuaB4ONvQuz_EoL8fhBzSuVm6x3N6I2SIEiq86U_rwwMeta } from "/builds/se-team/deli-web-portal-front/app/pages/activities/qinglvSettled/index.vue?macro=true";
import { default as resultaxqDVyAE4f0taPEDlD0hBvR1qfTJ_CsA_WhOjX351w0Meta } from "/builds/se-team/deli-web-portal-front/app/pages/help/result.vue?macro=true";
import { default as companySC_IkYEWOjNI9ValWZCNXLa4X5nFs6nbXmAkJG3ZZTYMeta } from "/builds/se-team/deli-web-portal-front/app/pages/news/company.vue?macro=true";
import { default as detailsuXkt3vmi40qV5BUPl_sMj2sIEx9U1hyRa1j5hycOUSwMeta } from "/builds/se-team/deli-web-portal-front/app/pages/news/details.vue?macro=true";
import { default as lawsAOBiYykn6P66GS2C8jsTHWDLLsPCjfjSRLfj0ivpuMgMeta } from "/builds/se-team/deli-web-portal-front/app/pages/news/laws.vue?macro=true";
import { default as index4E4fBYUSA0xQIro5GnToF9kYeAQuaElYg08DlQBkNusMeta } from "/builds/se-team/deli-web-portal-front/app/pages/siq/order/index.vue?macro=true";
import { default as lawFirmOYUb8okUQPxpGlTHSHK2yi_e32XvTv90nKT7XFzNGmkMeta } from "/builds/se-team/deli-web-portal-front/app/pages/solution/lawFirm.vue?macro=true";
import { default as lawyerJJLWyKiiHxSwjKmrMjc7eVdoDilw3l8dh4GiN2RdeCQMeta } from "/builds/se-team/deli-web-portal-front/app/pages/solution/lawyer.vue?macro=true";
import { default as privateLawyerXFkytymyMIye_jYnW_glOwlEYXCK_ckfMgFi2dvhKlUMeta } from "/builds/se-team/deli-web-portal-front/app/pages/solution/privateLawyer.vue?macro=true";
import { default as smartLaw5mFfI8CH_N8Bdqf_AxFUb6c4THvrESdQc3i6_OGA2hAMeta } from "/builds/se-team/deli-web-portal-front/app/pages/solution/smartLaw.vue?macro=true";
import { default as smartLegalCzlAW32FuvubL2horsOO6cBnXSYUHsGc4tMuLn_eIVEMeta } from "/builds/se-team/deli-web-portal-front/app/pages/solution/smartLegal.vue?macro=true";
import { default as _91id_93AS7gmixoAoIlBjSRWwqTeR0VD5k_UNI7u3ZGiQivRaIMeta } from "/builds/se-team/deli-web-portal-front/app/pages/news/[type]/[id].vue?macro=true";
import { default as _91id_93eC1FPj9ioDnB2m7D9RV4rq5sJieBVuyYjRGqMv1DVoMMeta } from "/builds/se-team/deli-web-portal-front/app/pages/s/[id].vue?macro=true";
import { default as indexCgyLjnVg6mEyAzxI_XmT_KA0WTpQxm7f_VnxTEU0aMAMeta } from "/builds/se-team/deli-web-portal-front/app/pages/search/[versionType]/index.vue?macro=true";
import { default as index_I8i_e3cwbKUqFWoF2yP03DyilJCUlwKO74maa5_iO0Meta } from "/builds/se-team/deli-web-portal-front/app/pages/about/index.vue?macro=true";
import { default as indexUCYfDEvgaRsFBwwZWbOPfmvHjdlabxsomn_j8UDPZ3UMeta } from "/builds/se-team/deli-web-portal-front/app/pages/ai/index.vue?macro=true";
import { default as indexgYVqvQzrdzNKF_fU6Q5_5m8QCtZLCi70U_TeoE6GUKEMeta } from "/builds/se-team/deli-web-portal-front/app/pages/aigc/index.vue?macro=true";
import { default as digitalHumantnwvHvebrB_jhAv_3IR4WKgucO_iwt0WtkWiEnpBCwQMeta } from "/builds/se-team/deli-web-portal-front/app/pages/digitalHuman.vue?macro=true";
import { default as loginKvd5m1ZuRPYaCb_ky0j6twnSa7T194lg9Xt_sYeAl_EMeta } from "/builds/se-team/deli-web-portal-front/app/pages/login.vue?macro=true";
import { default as indexG_N2h9d5XiqLef2idy4jepcyJbI9oJ5OssVsnC4xh2UMeta } from "/builds/se-team/deli-web-portal-front/app/pages/news/index.vue?macro=true";
import { default as oauthMt1_fGDtYpr3aPmYQIb313dRDmLKhkHOk_2ctVhLbdwMeta } from "/builds/se-team/deli-web-portal-front/app/pages/oauth.vue?macro=true";
import { default as indexM9xrCdQVI5x5BH_81X3_M5RGzk52bNuJnWSEnaDaYBYMeta } from "/builds/se-team/deli-web-portal-front/app/pages/paralegal/index.vue?macro=true";
import { default as indexAWZ9495zafvDTeRph6zn9suWSD3XVJlIUYDYnQh09ywMeta } from "/builds/se-team/deli-web-portal-front/app/pages/partner/index.vue?macro=true";
import { default as pdfViewer9gLCykzBeZ6q7TAB5HGlCZme3NFkEnLnZBCt0n6rv5MMeta } from "/builds/se-team/deli-web-portal-front/app/pages/pdfViewer.vue?macro=true";
import { default as questionb_FQar4ipQwxHfPj8c7me7dYou8AGwSLOk3rrz_lkm0Meta } from "/builds/se-team/deli-web-portal-front/app/pages/question.vue?macro=true";
import { default as indexAGioeElXisX908XZ7vAo50p7G_FG6O_xBRHPSsnKDPoMeta } from "/builds/se-team/deli-web-portal-front/app/pages/recruitment/index.vue?macro=true";
import { default as indexK0oNJLLkJzDmo0_8UiYOKH0cFmOONVMQauYrlZpub3AMeta } from "/builds/se-team/deli-web-portal-front/app/pages/settlement/index.vue?macro=true";
import { default as indexFj_28s3S9Zt1iHKwNKUJbNKog5i9Erntu9jSF5wTD6QMeta } from "/builds/se-team/deli-web-portal-front/app/pages/siq/index.vue?macro=true";
import { default as wpsOfficezSwCyBPW22P_TinSX1cs74B2C8GTeaR3nSMkCCVHQu0Meta } from "/builds/se-team/deli-web-portal-front/app/pages/wpsOffice.vue?macro=true";
import { default as index2VucCVtf4bIj0zJSJasvAAJIB1rGvEaHR6wMNEzX0soMeta } from "/builds/se-team/deli-web-portal-front/app/pages/index.vue?macro=true";
import { default as component_45stubLysimNtgt83Mlhauv3xhvbTWjb9Vni_EmoP0UCG_e_8Meta } from "/builds/se-team/deli-web-portal-front/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubLysimNtgt83Mlhauv3xhvbTWjb9Vni_EmoP0UCG_e_8 } from "/builds/se-team/deli-web-portal-front/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "h5-activities-qinglvSettled-form",
    path: "/h5/activities/qinglvSettled/form",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/activities/qinglvSettled/form.vue")
  },
  {
    name: "h5-activities-qinglvSettled-record",
    path: "/h5/activities/qinglvSettled/record",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/activities/qinglvSettled/record.vue")
  },
  {
    name: "ai-share-doc-id",
    path: "/ai/share/doc/:id()",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/ai/share/doc/[id].vue")
  },
  {
    name: "h5-siq-consultSetting-userId",
    path: "/h5/siq/consultSetting/:userId()",
    meta: _91userId_93QqUBGQuDHAE5HiQrsGFfgHExgeUuX_5Xadqgpda5gJcMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/siq/consultSetting/[userId].vue")
  },
  {
    name: "activities-qinglvSettled-form",
    path: "/activities/qinglvSettled/form",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/activities/qinglvSettled/form.vue")
  },
  {
    name: "h5-activities-bNVmxiSHyLd",
    path: "/h5/activities/bNVmxiSHyLd",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/activities/bNVmxiSHyLd.vue")
  },
  {
    name: "h5-activities-IJsaNibG",
    path: "/h5/activities/IJsaNibG",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/activities/IJsaNibG.vue")
  },
  {
    name: "h5-activities-JgdUoFf",
    path: "/h5/activities/JgdUoFf",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/activities/JgdUoFf.vue")
  },
  {
    name: "h5-activities-qinglvSettled",
    path: "/h5/activities/qinglvSettled",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/activities/qinglvSettled/index.vue")
  },
  {
    name: "h5-activities-shlxToData",
    path: "/h5/activities/shlxToData",
    meta: shlxToDataI8sZBPc8K_ek1FF2wiIGBtw1_5mxqarDVz8wG8LwF5IMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/activities/shlxToData.vue")
  },
  {
    name: "h5-activities-shlxToDls",
    path: "/h5/activities/shlxToDls",
    meta: shlxToDlsv6SyDYlo77uWBYYfcs0FSZOMBWfgY7kUeUZWvr3GzIAMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/activities/shlxToDls.vue")
  },
  {
    name: "h5-ai-agreement",
    path: "/h5/ai/agreement",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ai/agreement.vue")
  },
  {
    name: "h5-ai-caseDetail",
    path: "/h5/ai/caseDetail",
    meta: caseDetailVj5kE5B4__1sivi6TeCYz7XSoHxCJhg20oKebygT608Meta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ai/caseDetail.vue")
  },
  {
    name: "h5-ai-lawsDetail",
    path: "/h5/ai/lawsDetail",
    meta: lawsDetailEg8h_cushMXNGdlf9BpHDLdtqJPNnVt7hwAUoWTdKlsMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ai/lawsDetail.vue")
  },
  {
    name: "h5-ai-model",
    path: "/h5/ai/model",
    meta: modelt_5hoH4Eh_I1swYsfqred1vcgZ2tHdoJj6Aw_o28Tw8Meta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ai/model.vue")
  },
  {
    name: "h5-ai-siqModel",
    path: "/h5/ai/siqModel",
    meta: siqModelZYtWB5Rw8tgdYGJj_S3u5r1rEApdomF2SUGXyWFLj_sMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ai/siqModel.vue")
  },
  {
    name: "h5-dls-entry-form",
    path: "/h5/dls/entry-form",
    meta: indexJX9DR4zV7ill3DeP4C06Nsf9rectKKSTtPvpZFpWn_oMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/dls/entry-form/index.vue")
  },
  {
    name: "h5-dls-lawyer-certification",
    path: "/h5/dls/lawyer-certification",
    meta: indexgfslCBwHlN1gtRjOz8EfNVp31y5oUcb5JSmNfOiU_UwMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/dls/lawyer-certification/index.vue")
  },
  {
    name: "h5-dls-points",
    path: "/h5/dls/points",
    meta: pointsf2RHVsvKRRjbpw217Sj62V7EWhdibiPcd_9MjY5ZD28Meta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/dls/points.vue")
  },
  {
    name: "h5-dls-points-rules",
    path: "/h5/dls/points-rules",
    meta: indexLMK4DzKaEP0udrXookntbKwGQy_RdN3SlhFPmMPEyhUMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/dls/points-rules/index.vue")
  },
  {
    name: "h5-ft-aiSourceMessage",
    path: "/h5/ft/aiSourceMessage",
    meta: aiSourceMessageFZt0f9ggLXuYgO8V_G9mg059Wv5CsSG0AIffJhUPLHgMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ft/aiSourceMessage.vue")
  },
  {
    name: "h5-ft-businessCard",
    path: "/h5/ft/businessCard",
    meta: businessCardpllg5NuAoYbxGIJ4p2nYHR92G3J5lSvVI3Cxz1dma_gMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ft/businessCard.vue")
  },
  {
    name: "h5-ft-caseSourceMessage",
    path: "/h5/ft/caseSourceMessage",
    meta: caseSourceMessage8j2WyBlM5TMREMczJQC4R4qEaMp59890dG4jSGmS10IMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ft/caseSourceMessage.vue")
  },
  {
    name: "h5-ft-createCard",
    path: "/h5/ft/createCard",
    meta: createCardhVyFnwLxHyzNJ8hkY0z1i7_akAYg4hthL6VEgNSl_UkMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ft/createCard.vue")
  },
  {
    name: "h5-ft-help",
    path: "/h5/ft/help",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ft/help.vue")
  },
  {
    name: "h5-ft-knowledgeDetail",
    path: "/h5/ft/knowledgeDetail",
    meta: knowledgeDetailU4OiyvyjNT6YgzmT6bUqSVw_KCzLJWv7OgmqfJpz0S4Meta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ft/knowledgeDetail.vue")
  },
  {
    name: "h5-ft-lawyerBusinessCard",
    path: "/h5/ft/lawyerBusinessCard",
    meta: lawyerBusinessCardjAnYxAguSm37plDA_Zuggt4w7ZfqoKZYkX_kwANKFyIMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ft/lawyerBusinessCard.vue")
  },
  {
    name: "h5-ft-leaveMessage",
    path: "/h5/ft/leaveMessage",
    meta: leaveMessage_2lZ8Sv3eoj2yV7aEFxOe7n8VLdvJIT46an05rg_8qkMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ft/leaveMessage.vue")
  },
  {
    name: "h5-ft-reportView",
    path: "/h5/ft/reportView",
    meta: reportViewFSbCQUJ4UzIleuhdVjM0rkz3_3U_loLDX_5mhOqN2k0Meta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/ft/reportView.vue")
  },
  {
    name: "h5-siq-assistant",
    path: "/h5/siq/assistant",
    meta: assistantPlN6vmqGNwamXs1p13dbfyojzbgJd8pEucOxLHiVwcIMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/siq/assistant.vue")
  },
  {
    name: "h5-siq-home",
    path: "/h5/siq/home",
    meta: home_RYltP58VSUDSIuU7xBYDH1L5JQTxa6TXpX7nPXmwYEMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/siq/home.vue")
  },
  {
    name: "h5-siq-lawyerCard",
    path: "/h5/siq/lawyerCard",
    meta: lawyerCardeTnSSjwRhIq5DPINrI21c_IJj1wSyP1Xi3Rw5sEX6_IMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/siq/lawyerCard.vue")
  },
  {
    name: "h5-siq-order",
    path: "/h5/siq/order",
    meta: orderF9hvkjJfhP5Ngf32hNVf09jbJT89qsXxLMg7xHy9EhIMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/siq/order.vue")
  },
  {
    name: "h5-siq-order-detail",
    path: "/h5/siq/order-detail",
    meta: order_45detail1H06C8UeroZOC4Ld6casKC8P0JyCCtMYGP8mJQ1M1FwMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/h5/siq/order-detail.vue")
  },
  {
    name: "ai-share-id",
    path: "/ai/share/:id()",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/ai/share/[id].vue")
  },
  {
    name: "siq-consultLawyer-id",
    path: "/siq/consultLawyer/:id()",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/siq/consultLawyer/[id].vue")
  },
  {
    name: "activities-qinglvSettled",
    path: "/activities/qinglvSettled",
    meta: indexVuaB4ONvQuz_EoL8fhBzSuVm6x3N6I2SIEiq86U_rwwMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/activities/qinglvSettled/index.vue")
  },
  {
    name: "help-result",
    path: "/help/result",
    meta: resultaxqDVyAE4f0taPEDlD0hBvR1qfTJ_CsA_WhOjX351w0Meta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/help/result.vue")
  },
  {
    name: "news-company",
    path: "/news/company",
    meta: companySC_IkYEWOjNI9ValWZCNXLa4X5nFs6nbXmAkJG3ZZTYMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/news/company.vue")
  },
  {
    name: "news-details",
    path: "/news/details",
    meta: detailsuXkt3vmi40qV5BUPl_sMj2sIEx9U1hyRa1j5hycOUSwMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/news/details.vue")
  },
  {
    name: "news-laws",
    path: "/news/laws",
    meta: lawsAOBiYykn6P66GS2C8jsTHWDLLsPCjfjSRLfj0ivpuMgMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/news/laws.vue")
  },
  {
    name: "siq-order",
    path: "/siq/order",
    meta: index4E4fBYUSA0xQIro5GnToF9kYeAQuaElYg08DlQBkNusMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/siq/order/index.vue")
  },
  {
    name: "solution-lawFirm",
    path: "/solution/lawFirm",
    meta: lawFirmOYUb8okUQPxpGlTHSHK2yi_e32XvTv90nKT7XFzNGmkMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/solution/lawFirm.vue")
  },
  {
    name: "solution-lawyer",
    path: "/solution/lawyer",
    meta: lawyerJJLWyKiiHxSwjKmrMjc7eVdoDilw3l8dh4GiN2RdeCQMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/solution/lawyer.vue")
  },
  {
    name: "solution-privateLawyer",
    path: "/solution/privateLawyer",
    meta: privateLawyerXFkytymyMIye_jYnW_glOwlEYXCK_ckfMgFi2dvhKlUMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/solution/privateLawyer.vue")
  },
  {
    name: "solution-smartLaw",
    path: "/solution/smartLaw",
    meta: smartLaw5mFfI8CH_N8Bdqf_AxFUb6c4THvrESdQc3i6_OGA2hAMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/solution/smartLaw.vue")
  },
  {
    name: "solution-smartLegal",
    path: "/solution/smartLegal",
    meta: smartLegalCzlAW32FuvubL2horsOO6cBnXSYUHsGc4tMuLn_eIVEMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/solution/smartLegal.vue")
  },
  {
    name: "news-type-id",
    path: "/news/:type()/:id()",
    meta: _91id_93AS7gmixoAoIlBjSRWwqTeR0VD5k_UNI7u3ZGiQivRaIMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/news/[type]/[id].vue")
  },
  {
    name: "s-id",
    path: "/s/:id()",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/s/[id].vue")
  },
  {
    name: "search-versionType",
    path: "/search/:versionType()",
    meta: { ...(indexCgyLjnVg6mEyAzxI_XmT_KA0WTpQxm7f_VnxTEU0aMAMeta || {}), ...{"middleware":["search"]} },
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/search/[versionType]/index.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: index_I8i_e3cwbKUqFWoF2yP03DyilJCUlwKO74maa5_iO0Meta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/about/index.vue")
  },
  {
    name: "ai",
    path: "/ai",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/ai/index.vue")
  },
  {
    name: "aigc",
    path: "/aigc",
    meta: indexgYVqvQzrdzNKF_fU6Q5_5m8QCtZLCi70U_TeoE6GUKEMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/aigc/index.vue")
  },
  {
    name: "digitalHuman",
    path: "/digitalHuman",
    meta: digitalHumantnwvHvebrB_jhAv_3IR4WKgucO_iwt0WtkWiEnpBCwQMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/digitalHuman.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/login.vue")
  },
  {
    name: "news",
    path: "/news",
    meta: indexG_N2h9d5XiqLef2idy4jepcyJbI9oJ5OssVsnC4xh2UMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/news/index.vue")
  },
  {
    name: "oauth",
    path: "/oauth",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/oauth.vue")
  },
  {
    name: "paralegal",
    path: "/paralegal",
    meta: indexM9xrCdQVI5x5BH_81X3_M5RGzk52bNuJnWSEnaDaYBYMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/paralegal/index.vue")
  },
  {
    name: "partner",
    path: "/partner",
    meta: indexAWZ9495zafvDTeRph6zn9suWSD3XVJlIUYDYnQh09ywMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/partner/index.vue")
  },
  {
    name: "pdfViewer",
    path: "/pdfViewer",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/pdfViewer.vue")
  },
  {
    name: "question",
    path: "/question",
    redirect: "/aigc",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/question.vue")
  },
  {
    name: "recruitment",
    path: "/recruitment",
    meta: indexAGioeElXisX908XZ7vAo50p7G_FG6O_xBRHPSsnKDPoMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/recruitment/index.vue")
  },
  {
    name: "settlement",
    path: "/settlement",
    meta: indexK0oNJLLkJzDmo0_8UiYOKH0cFmOONVMQauYrlZpub3AMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/settlement/index.vue")
  },
  {
    name: "siq",
    path: "/siq",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/siq/index.vue")
  },
  {
    name: "wpsOffice",
    path: "/wpsOffice",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/wpsOffice.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index2VucCVtf4bIj0zJSJasvAAJIB1rGvEaHR6wMNEzX0soMeta || {},
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/index.vue")
  },
  {
    name: "siq-ai",
    path: "/siq/ai",
    component: () => import("/builds/se-team/deli-web-portal-front/app/pages/ai/index.vue")
  },
  {
    name: component_45stubLysimNtgt83Mlhauv3xhvbTWjb9Vni_EmoP0UCG_e_8Meta?.name,
    path: "/help",
    component: component_45stubLysimNtgt83Mlhauv3xhvbTWjb9Vni_EmoP0UCG_e_8
  },
  {
    name: component_45stubLysimNtgt83Mlhauv3xhvbTWjb9Vni_EmoP0UCG_e_8Meta?.name,
    path: "/office",
    component: component_45stubLysimNtgt83Mlhauv3xhvbTWjb9Vni_EmoP0UCG_e_8
  },
  {
    name: component_45stubLysimNtgt83Mlhauv3xhvbTWjb9Vni_EmoP0UCG_e_8Meta?.name,
    path: "/web/ai/model",
    component: component_45stubLysimNtgt83Mlhauv3xhvbTWjb9Vni_EmoP0UCG_e_8
  }
]